import PropTypes from 'prop-types';

const amounts = PropTypes.shape({
  add_ons: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      name: PropTypes.string,
      totalCost: PropTypes.number,
    })
  ),
  price_per_unit: PropTypes.number,
  quantity: PropTypes.number,
  reservation_charge: PropTypes.number,
  resy_fee: PropTypes.number,
  service_charge: PropTypes.shape({
    amount: PropTypes.number,
    value: PropTypes.string,
  }),
  subtotal: PropTypes.number,
  surcharge: PropTypes.number,
  tax: PropTypes.number,
  total: PropTypes.number,
});

export const options = PropTypes.arrayOf(
  PropTypes.shape({
    amount: PropTypes.shape({
      add_ons: PropTypes.number,
      price_per_unit: PropTypes.number,
      resy_fee: PropTypes.number,
      service_charge: PropTypes.shape({
        amount: PropTypes.number,
        value: PropTypes.string,
        tax: PropTypes.number,
        total: PropTypes.number,
      }),
    }),
  })
);

const payment = PropTypes.shape({
  amounts,
  options,
});

const reservationDetailsShape = PropTypes.shape({
  cancellation: PropTypes.shape({
    display: PropTypes.shape({
      policy: PropTypes.arrayOf(
        PropTypes.string
      ),
    }),
  }),
  config: PropTypes.shape({
    add_ons: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        option: PropTypes.string,
      })
    ),
    features: PropTypes.arrayOf(
      PropTypes.string
    ),
    menu_items: PropTypes.arrayOf(
      PropTypes.string
    ),
    service_charge_options: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number,
        display: PropTypes.string,
      })
    ),
  }),
  isGda: PropTypes.bool,
  payment,
  venue: PropTypes.shape({
    menu_items: PropTypes.arrayOf(
      PropTypes.string
    ),
  }),
});

export default reservationDetailsShape;
